<template>
  <v-dialog v-model="postGallary" persistent scrollable width="800">
    <v-card>
      <v-card-title> 記事一覧 </v-card-title>
      <v-card-text>
        <v-layout>
          <v-text-field
            v-model="keyword"
            label="キーワード"
            style="max-width: 400px"
            class="ms-5 me-4"
          />
          <v-btn
            color="primary"
            dark
            tile
            outlined
            small
            class="ma-3"
            @click="searchPosts"
          >
            絞り込む
          </v-btn>
        </v-layout>
        <v-container fluid class="px-0">
          <v-card
            v-for="post in setSelectedFlagPosts"
            :key="post.id"
            outlined
            tile
            @mouseover="overlayPostId = post.id"
            @mouseleave="overlayPostId = null"
          >
            <v-container fluid class="pa-2">
              <v-row>
                <v-col lg="2">
                  <v-avatar class="profile" size="100" tile>
                    <v-img :src="eyecatchableSrc(post)" />
                  </v-avatar>
                </v-col>
                <v-col lg="10">
                  <div class="subtitle-2 pb-2">
                    {{ post.title }}
                  </div>
                  <p class="caption">
                    {{ post.introduction }}
                  </p>
                </v-col>
              </v-row>
            </v-container>
            <v-overlay absolute :value="overlayPostId === post.id">
              <v-btn tile class="ma-2" @click="previewPost(post)">
                <v-icon class="mr-2"> mdi-eye </v-icon>
                PREVIEW
              </v-btn>
              <v-btn
                tile
                color="success"
                class="ma-2"
                @click="selectPost(post)"
              >
                <v-icon class="mr-2"> mdi-check </v-icon>
                SELECT
              </v-btn>
            </v-overlay>
          </v-card>
          <infinite-loading
            spinner="spiral"
            :identifier="infiniteId"
            @infinite="infiniteHandler"
          >
            <template v-slot:no-more>
              <v-chip class="mt-10" label color="teal" text-color="white">
                <v-avatar left>
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>
                ALL CONTENTS HAVE BEEN SHOWN ！
              </v-chip>
            </template>
            <template v-slot:no-results>
              <v-chip
                class="mt-10"
                label
                large
                color="amber"
                text-color="white"
              >
                <v-avatar left>
                  <v-icon>mdi-close-circle</v-icon>
                </v-avatar>
                No Results
              </v-chip>
            </template>
          </infinite-loading>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="closePostGallary">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'

export default {
  components: {
    InfiniteLoading
  },
  props: {
    postGallary: {
      type: Boolean,
      required: true
    },
    selectdPostIds: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  data: () => {
    return {
      page: 1,
      overlayPostId: null,
      posts: [],
      keyword: null,
      infiniteId: +new Date()
    }
  },
  computed: {
    eyecatchableSrc () {
      return function (post) {
        if (post.eyecatchable) {
          return post.eyecatchable.file.middle.url
        } else {
          return 'http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image'
        }
      }
    },
    setSelectedFlagPosts () {
      return this.posts.filter((post) => { return !this.selectdPostIds.includes(post.id) })
    }
  },
  methods: {
    searchPosts () {
      this.page = 1
      this.posts = []
      this.infiniteId++
    },
    infiniteHandler ($state) {
      axios
        .get('/api/posts', {
          params: {
            page: this.page,
            q: {
              status_eq: 1,
              keyword: this.keyword
            }
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedPosts = data.data
          if (fetchedPosts.length) {
            this.page++
            for (const i in fetchedPosts) {
              const post = fetchedPosts[i].attributes
              this.posts.push(post)
            }
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    closePostGallary () {
      this.$emit('close-post-gallary')
    },
    selectPost (post) {
      this.$emit('select-post', post)
      this.closePostGallary()
    },
    previewPost (post) {
      window.open('/preview/' + post.id, '_blank')
    }
  }
}
</script>

<style scoped></style>
